<div
  class="syn-multi-select-container"
  [ngClass]="{ 'theme-transparent': theme() === 'transparent' }">
  <mat-form-field
    class="multi-select-form-field"
    [ngClass]="{ 'multi-select-panel-open': matMultiSelect.panelOpen }"
    subscriptSizing="dynamic">
    <div class="select-display-label">
      @if (labelPosition() === 'before') {
        <mat-icon class="label-icon">{{ labelIcon() }}</mat-icon>
      }
      <span class="label-text">{{ labelText() }}</span>
      @if (
        labelPosition() === 'after' &&
        (!selectFormCtrl.value || selectFormCtrl.value?.length === 0)
      ) {
        <mat-icon class="label-icon">{{ labelIcon() }}</mat-icon>
      }
    </div>
    <mat-select
      #matMultiSelect
      class="multi-select"
      [formControl]="selectFormCtrl"
      [panelWidth]="panelWidth()"
      multiple
      panelClass="syn-multi-select-panel">
      <mat-select-trigger class="select-trigger">
        @if (selectedCount() > 0) {
          <span class="selection-chip">
            {{ isAllSelected() ? 'All' : selectedCount() }}
          </span>
        }

        @if (labelPosition() === 'after' && selectFormCtrl.value?.length > 0) {
          <mat-icon class="label-icon">{{ labelIcon() }}</mat-icon>
        }
      </mat-select-trigger>

      <!-- https://github.com/angular/components/issues/5697 -->
      <!-- https://stackblitz.com/edit/angular-mat-select-multi-with-formcontrol-x2tbvo?file=app%2Fselect-search-dropdown.component.html -->
      <!-- Fixed header (search + Select All) sits outside the scroll area. -->
      <div class="panel-search">
        <div class="panel-search-label">
          {{ labelSearch() }}
        </div>

        <!-- TODO: @later create a syn-search-input component -->
        <div class="search-input-container">
          <mat-icon>search</mat-icon>
          <input
            matInput
            class="panel-search-input"
            [formControl]="searchFormCtrl"
            placeholder="Search"
            type="text" />
        </div>
      </div>

      @if (filteredOptions().length > 1) {
        <div class="select-all-wrapper">
          <mat-option
            #allOptionElement
            class="multi-select-option select-all-option"
            [value]="ALL_OPTION"
            (onSelectionChange)="toggleAllChange(allOptionElement, $event)">
            {{ allOptionElement.selected ? 'Deselect All' : 'Select All' }}
          </mat-option>
        </div>
      }

      <!-- Only the option list scrolls. -->
      <div class="syn-multi-select-panel-content">
        @if (filteredOptions().length > 0) {
          @for (option of filteredOptions(); track option) {
            <mat-option
              #optionElement
              class="multi-select-option"
              [value]="option"
              (onSelectionChange)="toggleOptionChange(optionElement, $event)">
              {{ displayOption(option) }}
            </mat-option>
          }
        } @else {
          <div class="panel-no-options">No options matches the search term</div>
        }
      </div>

      <div class="syn-multi-select-panel-footer">
        <button class="btn-primary-default" (click)="applySelection()">
          Apply
        </button>
      </div>
    </mat-select>
  </mat-form-field>
</div>
